import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// @ts-expect-error migrate upstream
import { selectIsFreePortal } from 'dashboard-lib/public/userInfo/scopes';
import { FTS0015_TREATMENT_KEY, GROUP_PARAMETER_KEY, GROUP_PARAMETER_OPTIONS, PARAMETERS } from '../constants/ExperimentKeys';
import { laboratoryClient } from '../data/laboratoryClient';
export const logFTS0015Exposure = () => {
  laboratoryClient.logExposure(FTS0015_TREATMENT_KEY);
};

// https://tools.hubteam.com/laboratory/experiments/edit/fts-0015?tab=workflow&step=0
export const useIsFTS0015Variant = isEligibleForFTS0015 => {
  const [isFTS0015Variant, setIsFTS0015Variant] = useState(false);
  const [isFTS0015Fetched, setIsFTS0015Fetched] = useState(false);
  const isFreePortal = useSelector(selectIsFreePortal);
  useEffect(() => {
    if (isFreePortal && isEligibleForFTS0015 && !isFTS0015Fetched) {
      laboratoryClient.resolve(treatments => {
        if (Object.keys(treatments).length) {
          const treatment = treatments[FTS0015_TREATMENT_KEY];
          const cohort = treatment[PARAMETERS][GROUP_PARAMETER_KEY];
          const isVariant = cohort === GROUP_PARAMETER_OPTIONS.variant;
          setIsFTS0015Variant(isVariant);
        }
        setIsFTS0015Fetched(true);
        logFTS0015Exposure();
      });
    }
  }, [isFTS0015Fetched, isFreePortal, isEligibleForFTS0015]);
  return {
    isFTS0015Variant,
    isFTS0015Fetched
  };
};